<template>
    <div class="visitSubmission">
        <van-nav-bar fixed>
            <div slot="left" @click="close" class="icon-title-line">
                <van-icon name="arrow-left" color="#333" class="icon-title-size" />
            </div>
        </van-nav-bar>
        <visit-submission-details :vTitle="title" :vText="text" :btnText="btnText" :queryphone="queryphone" :queryIdCard="queryIdCard" :queryIsManyTimes="queryIsManyTimes"  @onVisitList="onVList"></visit-submission-details>
    </div>
</template>
<script>
import VisitSubmissionDetails from "../../components/VisitSubmissionDetails";
export default {
    name:'VisitSubmission',
    components:{
        VisitSubmissionDetails
    },
    data(){
        return{
           title:['您的申请已提交','您的申请撤销信息已提交','您的审批已提交','您的申请已提交','很抱歉，您当日没有预约','您是家长用户，请通过用户名和密码登录智校'],
           text:['申请信息已发送相关人员','撤销信息已发送相关人员','审批结果已发送相关人员','可通过登录系统查询详细信息'],
           btnText:['登录查询','查看详情'],
           queryid:'',
           queryphone:'',
           queryIdCard:'',
           queryIsManyTimes:false, //false第一次申请
           VisitorRecordID:0, //id
           list:[],
           accountList: [],
           accountId:0
        }
    },
    computed: {
        userInfo () {
                return this.$store.state.common.userInfo
            }
    },
    created(){
        this.queryid = this.$route.query.isFrom
        this.queryphone = this.$route.query.VisitorPhoneNumber?this.$route.query.VisitorPhoneNumber:''
        this.queryIdCard = this.$route.query.VisitorIdCard?this.$route.query.VisitorIdCard:''
        // this.queryIsManyTimes = this.$route.query.IsManyTimes
        this.queryIsManyTimes = this.$route.query.IsManyTimes?this.$route.query.IsManyTimes:false
        this.accountId = localStorage.getItem('accountId')
        console.log(this.queryIsManyTimes)
        this.VisitorRecordID = this.$route.query.VisitorRecordID
        if(this.queryid === 'VisitApplyGo'){
            this.title = this.title[3]
            this.text = this.text[3]
            this.btnText = this.btnText[0]
            this.userInfo.Admin = false
            console.log(this.userInfo.Admin)
        }else if(this.queryid === 'VisitApply'){
            this.title = this.title[0]
            this.text = this.text[0]
            this.btnText = this.btnText[1]
        }
        else if(this.queryid === 'Visitrevoke'){
            this.title = this.title[1]
            this.text = this.text[1]
            this.btnText = this.btnText[1]
        }else if(this.queryid === 'ApprovalComments'){
            this.title = this.title[2]
            this.text = this.text[2]
            this.btnText = this.btnText[1]
        }else if(this.queryid ==='visitapplydetail'){
            this.title = this.title[4]
            this.text = ''
            this.btnText = ''
        }else if(this.queryid ==='家长'){
            this.title = this.title[5]
            this.text = ''
            this.btnText = this.btnText[0]
        }
    },
    methods:{
      async getFrequently() {
        this.xy.loading();
        this.list = [];
        let res = await this.xyapi.get(this.xyMApi + "/xy/comm/MobileMoudle")
        if(res !== undefined && res.success){
            this.list = res.data.Modules
            for(let i=0;i<this.list.length;i++){
                if(this.list[i].Name === '智慧校务' || this.list[i].ID === 6 || this.list[i].ModuleCode === 'sa'){
                    for(let j=0;j<this.list[i].applications.length;j++){
                            if(this.list[i].applications[j].ApplicationDescription === '访客预约' || this.list[i].applications[j].MID === 6 || this.list[i].applications[j].Code === 'saVisitor'){
                            this.funcBtn(this.list[i],this.list[i].applications[j])
                            console.log(this.list[i],this.list[i].applications[j])
                            return
                        }
                    }
                }
            }
        }
        this.xy.unloading();
        },
      funcBtn(pval,vals) {
        this.$store.commit('changeApiPath', `${this.xyMApi}/${pval.ModuleCode}`)
        localStorage.setItem("breadcrumb", JSON.stringify(vals));
        if (vals.MobileUrl) {
          localStorage.setItem("navTitle", vals.Name);
          this.$router.push(vals.MobileUrl);
        } else {
          localStorage.setItem("navTitle", vals.subMenu[0].Name);
          this.$router.push(vals.subMenu[0].ApplicationSubMenuMobileUrl);
        }
        this.$store.commit("common/getMenuIDs", [vals.MID, vals.ID]);
      },
        close(){
            if(this.queryid === 'VisitApply' || this.queryid === 'Visitrevoke' || this.queryid ==='家长'){
                this.$router.go(-2) 
            }else if(this.queryid === 'ApprovalComments'){
                this.$router.go(-2)
            }else if(this.queryid ==='visitapplydetail'){
                this.getFrequently()
            }
            else{
                this.$router.go(-1) 
            }
        },
       async onVList(){
            if(this.queryid === 'VisitApply' || this.queryid === 'Visitrevoke'){
                console.log(this.VisitorRecordID)
                this.$router.push({
                    path:'/home/VisitDetails',
                    query:{
                        VisitorRecordID:this.VisitorRecordID,
                        isVisitor:true,
                        isFrom:'VisitApplyRevoke'
                    }
                    })
            }else if(this.queryid ==='家长'){
                this.$router.push({
                    path:'/login'
                })
            }else if(this.queryid === 'VisitApplyGo'){  //访客预约
                //获取token
                let queryIdCard = 'XY' + this.queryIdCard.slice(-6) 
                let params = {
                    AccountID: Number(this.accountId),
                    LoginId: this.queryphone,
                    Password: this.xy.encrypt(queryIdCard)
                };
                let res = await this.xyapi.post(
                    this.xyMApi + "/xy/login",
                    params
                );
                if (res.success) {
                    let value = res.data.token;
                    localStorage.setItem("role", res.data.role);
                    if (value) {
                        this.xy.setCookie(value);
                        if (this.xy.getCookie(".XYTOKEN")) {
                            this.xy.msgSuc("登录成功");
                            this.getFrequently()   
                        } else {
                            this.xy.msgError("登录失败");
                        }
                    } else {
                    this.xy.msgError("登录失败");
                    }
                } else {
                    this.xy.msgError("登录失败");
                }
            }else if(this.queryid === 'ApprovalComments'){ //审批
                this.$router.push({
                    path:'/home/VisitDetails',
                    query:{
                        VisitorRecordID:this.VisitorRecordID,
                        isFrom:'ApprovalComments'
                    }
                })
            }
        }
    }
}
</script>
<style lang="less" scoped>
.icon-title-line{
  display: flex;
  align-items: center;
}
.icon-title-size{
  font-size: 38px;
}
</style>